/* Bridge: NEW Préprod cart drawer on Gastrolux Noël theme */
(function(){
  const currentDrawer=()=>document.querySelector('#shopify-section-cart-drawer cart-drawer');
  let pendingRefresh=null;
  async function refreshDrawer(open){
    const drawer=currentDrawer();
    if(!drawer)return;
    try{
      await drawer.refresh(Boolean(open),document.activeElement);
      const cart=await drawer.getCart();
      drawer.updateHeaderCount(cart.item_count);
      document.querySelectorAll('#site-control .cart-icon--basket1 .cart-count,#site-control .cart-icon--basket2 .cart-count').forEach(el=>{el.textContent=cart.item_count});
    }catch(error){
      if(open)drawer.open(document.activeElement);
      if(window.Shopify&&window.Shopify.designMode)console.warn('Cart drawer refresh:',error);
    }
  }
  const scheduleRefresh=(open)=>{clearTimeout(pendingRefresh);pendingRefresh=setTimeout(()=>refreshDrawer(open),150)};
  window.openCartDrawer=function(){const drawer=currentDrawer();if(!drawer)return;return refreshDrawer(true)};
  window.closeCartDrawer=function(){currentDrawer()?.close()};
  window.reloadCartDrawer=function(){return refreshDrawer(false)};
  document.addEventListener('cart:updated',function(event){
    const count=event.detail?.cart?.item_count;
    if(Number.isFinite(count))currentDrawer()?.updateHeaderCount(count);
  });
  function isCartMutation(url){
    if(!url)return null;
    const path=String(url).split('?')[0];
    if(/\/cart\/add(?:\.js)?$/.test(path))return 'add';
    if(/\/cart\/(?:change|update|clear)(?:\.js)?$/.test(path))return 'change';
    return null;
  }
  if(window.jQuery){
    window.jQuery(document).ajaxSuccess(function(e,xhr,options){
      const kind=isCartMutation(options?.url);
      if(kind)scheduleRefresh(kind==='add');
    });
  }
  const nativeFetch=window.fetch;
  if(typeof nativeFetch==='function'&&!window.__gweNewCartFetchBridge){
    window.__gweNewCartFetchBridge=true;
    window.fetch=function(){
      const args=arguments;
      const input=args[0],init=args[1]||{};
      const url=typeof input==='string'?input:input?.url;
      const method=(init.method||input?.method||'GET').toUpperCase();
      const kind=method==='GET'?null:isCartMutation(url);
      return nativeFetch.apply(this,args).then(function(response){
        if(kind&&response.ok)scheduleRefresh(kind==='add');
        return response;
      });
    };
  }
})();
